/**
 * Input sanitization utilities for XSS prevention
 */

// Simple HTML/script tag sanitization
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  
  return input
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;')
    .trim();
};

// Sanitize email input (allow email-valid characters only)
export const sanitizeEmail = (email) => {
  if (typeof email !== 'string') return email;
  
  // Remove any characters not valid in email addresses
  return email
    .replace(/[^a-zA-Z0-9@._-]/g, '')
    .toLowerCase()
    .trim();
};

// Sanitize OTP input (numbers only)
export const sanitizeOTP = (otp) => {
  if (typeof otp !== 'string') return otp;
  
  // Remove any non-digit characters
  return otp.replace(/[^0-9]/g, '').slice(0, 6);
};

// Sanitize name input (letters, spaces, hyphens only)
export const sanitizeName = (name) => {
  if (typeof name !== 'string') return name;
  
  return name
    .replace(/[^a-zA-Z\s\-']/g, '')
    .trim()
    .slice(0, 100); // Enforce max length
};

// Sanitize company name
export const sanitizeCompany = (company) => {
  if (typeof company !== 'string') return company;
  
  return company
    .replace(/[<>"/]/g, '') // Remove basic XSS characters
    .trim()
    .slice(0, 200); // Enforce max length
};

// Generic sanitization for display text
export const sanitizeDisplayText = (text) => {
  if (typeof text !== 'string') return text;
  
  return sanitizeInput(text);
};